<script lang="ts" setup>
import type { BreadcrumbListProps } from '.';

import { cn } from '@/utils';

const props = defineProps<BreadcrumbListProps>();
</script>

<template>
	<ol :class="cn('flex flex-wrap items-center gap-3 break-words', props.class)">
		<slot />
	</ol>
</template>
